import { TabsType } from '..';
import Tab from './Tab';

type QualificationsType = {
  tabs: TabsType[];
  selectedTab: number;
  setSelectedTab: (index: number) => void;
};

const Qualifications = ({ tabs, selectedTab, setSelectedTab }: QualificationsType) => {
  return (
    <div>
      <ul className="w-full">
        {tabs.map((tab: TabsType, index: number) => (
          <Tab
            tabLogo={tab.tabLogo}
            tabTitle={tab.tabTitle}
            key={index}
            index={index}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        ))}
      </ul>
      <p>{tabs[selectedTab].tabMessage}</p>
    </div>
  );
};

export default Qualifications;
